import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class SettingHeader extends Component {
  componentDidMount() {}

  render() {
    const { state, t } = this.props;
    const activeClassName = 'active';

    return (
      <div className="setting_header">
        <div className="setting_header_inner">
          <div className="setting_header_box">
            <nav className="setting_lnb">
              <NavLink
                to="/settings/issue"
                className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
              >
                {t('modal.title.issue')}
              </NavLink>
              <NavLink
                to="/settings/project"
                className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
              >
                {t('project.menu.project')}
              </NavLink>
              <NavLink
                to="/settings/policy"
                className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
              >
                {t('project.menu.policy')}
              </NavLink>
              <NavLink
                to="/settings/precision"
                className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
              >
                {t('settings.list.precision')}
              </NavLink>
              {
                state.user.isAdmin
                && (
                  <NavLink
                    to="/settings/defined"
                    className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
                  >
                    {t('settings.list.defined_result')}
                  </NavLink>
                )
              }
              <NavLink
                to="/settings/crypto"
                className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
              >
                Cryptography
              </NavLink>
              <NavLink
                to="/settings/leakage"
                className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
              >
                {t('card.menu.leakage')}
              </NavLink>
              <NavLink
                to="/settings/continuous_scan"
                className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
              >
                {t('settings.list.continuous_scan')}
              </NavLink>
              <NavLink
                to="/settings/user"
                className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
              >
                {t('settings.list.user')}
              </NavLink>
              {state.user.isUser && (
                <NavLink
                  to="/settings/groups"
                  className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
                >
                  {t('settings.list.group')}
                </NavLink>
              )}
            </nav>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(inject('state')(observer(SettingHeader)));
